module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dof-card weex-ct weex-div",
    style: (_vm._px2rem(_vm._cardStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "dof-card-header weex-ct weex-div",
    style: (_vm._px2rem(_vm._cardWrapperStyle, 75)),
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.onSelect($event)
      }
    }
  }, [(_vm.isActive) ? _c('div', {
    staticClass: "dof-card-header-tag weex-ct weex-div",
    style: ({
      backgroundColor: _vm._tagBg
    }),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('figure', {
    staticClass: " weex-el weex-image",
    class: [_vm._isColmo ? 'dof-card-header-tag-confirm-colmo' : 'dof-card-header-tag-confirm'],
    attrs: {
      "src": _vm._isColmo ? _vm.confirm.colmo : _vm.confirm.default,
      "data-img-src": _vm._isColmo ? _vm.confirm.colmo : _vm.confirm.default,
      "weex-type": "image"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dof-card-header-content weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_vm._t("default", null, {})], 2), _vm._v(" "), (_vm.collapsable) ? _c('div', {
    staticClass: "dof-card-header-arrow-wrapper weex-ct weex-div",
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.onCollapse($event)
      }
    }
  }, [(_vm._isColmo) ? _c('dof-switch', {
    attrs: {
      "checked": !_vm.collapsed_,
      "data-evt-dofChange": ""
    },
    on: {
      "dofChange": _vm.onCollapse
    }
  }) : _c('figure', {
    ref: "arrow",
    staticClass: "dof-card-header-arrow weex-el weex-image",
    attrs: {
      "src": _vm.arrowUp,
      "data-img-src": _vm.arrowUp,
      "weex-type": "image"
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.collapsable) ? _c('div', {
    ref: "body",
    staticClass: "dof-card-body weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_vm._t("body", null, {})], 2) : _vm._e(), _vm._v(" "), (_vm.dotConfig.normalColor && _vm.dotConfig.clickedColor) ? _c('div', {
    staticClass: "dof-card-dot weex-ct weex-div",
    style: ({
      backgroundColor: _vm.clicked_ ? _vm.dotConfig.clickedColor : _vm.dotConfig.normalColor
    }),
    attrs: {
      "weex-type": "div"
    }
  }) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3f24858b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f24858b","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-card/index.vue
// module id = 607
// module chunks = 0 1